import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Heart, Shield, TrendingUp } from 'lucide-react';

interface SignUpPromptProps {
  onDismiss?: () => void;
}

const SignUpPrompt = ({ onDismiss }: SignUpPromptProps) => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/auth', { state: { from: location.pathname } });
  };

  const benefits = [
    {
      icon: Heart,
      title: "Track Your Health",
      description: "Save and monitor your health assessments over time"
    },
    {
      icon: Shield,
      title: "Secure & Private",
      description: "Your health data is encrypted and protected"
    },
    {
      icon: TrendingUp,
      title: "Progress Insights",
      description: "See trends and patterns in your health journey"
    }
  ];

  return (
    <Card className="w-full max-w-2xl mx-auto border-2 border-primary/20 bg-gradient-to-br from-blue-50/50 to-green-50/50">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl font-bold text-primary">
          Save Your Health Journey
        </CardTitle>
        <CardDescription className="text-lg">
          Create a free account to track your assessments and monitor your health over time
        </CardDescription>
      </CardHeader>
      
      <CardContent className="space-y-6">
        <div className="grid gap-4 md:grid-cols-3">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center space-y-2">
              <div className="w-12 h-12 mx-auto bg-primary/10 rounded-full flex items-center justify-center">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-semibold text-sm">{benefit.title}</h3>
              <p className="text-xs text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button 
            onClick={handleSignUp}
            className="flex-1 min-h-[48px] text-base font-semibold"
          >
            Create Free Account
          </Button>
          
          {onDismiss && (
            <Button 
              variant="outline"
              onClick={onDismiss}
              className="flex-1 min-h-[48px]"
            >
              Maybe Later
            </Button>
          )}
        </div>
        
        <p className="text-xs text-center text-muted-foreground">
          Free forever • No credit card required • Takes 30 seconds
        </p>
      </CardContent>
    </Card>
  );
};

export default SignUpPrompt;